<template>
<section class="headline">
	<div class="border-img">
		<img src="~@/assets/img/img_sectionheader_topbar.png" />
	</div>
	<div class="container">
		<div class="headline-lg">{{title}}</div>
	</div>
	<div class="border-img">
		<img src="~@/assets/img/img_sectionheader_bottombar.png" />
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionHeadline',
	props: {
		title: String
	}
}
</script>
